/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignProgressStatus } from './PromotionCampaignProgressStatus';
import {
    PromotionCampaignProgressStatusFromJSON,
    PromotionCampaignProgressStatusFromJSONTyped,
    PromotionCampaignProgressStatusToJSON,
} from './PromotionCampaignProgressStatus';

/**
 * Promotion trigger event summary for back office
 * Contains audit trail information about this specific trigger event
 * @export
 * @interface PromotionTriggerEventSummary
 */
export interface PromotionTriggerEventSummary {
    /**
     * Reason for failure if status is FAILED
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    failureReason?: string | null;
    /**
     * Status of this trigger event attempt
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    status: string;
    /**
     * When this event was created
     * @type {Date}
     * @memberof PromotionTriggerEventSummary
     */
    createdAt: Date;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof PromotionTriggerEventSummary
     */
    eventData: { [key: string]: any; };
    /**
     * 
     * @type {PromotionCampaignProgressStatus}
     * @memberof PromotionTriggerEventSummary
     */
    campaignStatus: PromotionCampaignProgressStatus;
    /**
     * Total rewards issued at this point
     * @type {number}
     * @memberof PromotionTriggerEventSummary
     */
    rewardsIssuedTotal: number;
    /**
     * Progress count after this trigger
     * @type {number}
     * @memberof PromotionTriggerEventSummary
     */
    progressCountAfter: number;
    /**
     * Progress count before this trigger
     * @type {number}
     * @memberof PromotionTriggerEventSummary
     */
    progressCountBefore: number;
    /**
     * ID of the reward issued, if any
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    rewardIssuedId?: string | null;
    /**
     * Whether this trigger qualified for a reward
     * @type {boolean}
     * @memberof PromotionTriggerEventSummary
     */
    qualifiedForReward: boolean;
    /**
     * Type of trigger (e.g., "TICKET_SCAN")
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    triggerType: string;
    /**
     * ID of the promotion campaign
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    campaignId: string;
    /**
     * ID of the trigger event
     * @type {string}
     * @memberof PromotionTriggerEventSummary
     */
    id: string;
}



/**
 * Check if a given object implements the PromotionTriggerEventSummary interface.
 */
export function instanceOfPromotionTriggerEventSummary(value: object): value is PromotionTriggerEventSummary {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('eventData' in value) || value['eventData'] === undefined) return false;
    if (!('campaignStatus' in value) || value['campaignStatus'] === undefined) return false;
    if (!('rewardsIssuedTotal' in value) || value['rewardsIssuedTotal'] === undefined) return false;
    if (!('progressCountAfter' in value) || value['progressCountAfter'] === undefined) return false;
    if (!('progressCountBefore' in value) || value['progressCountBefore'] === undefined) return false;
    if (!('qualifiedForReward' in value) || value['qualifiedForReward'] === undefined) return false;
    if (!('triggerType' in value) || value['triggerType'] === undefined) return false;
    if (!('campaignId' in value) || value['campaignId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PromotionTriggerEventSummaryFromJSON(json: any): PromotionTriggerEventSummary {
    return PromotionTriggerEventSummaryFromJSONTyped(json, false);
}

export function PromotionTriggerEventSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionTriggerEventSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'eventData': json['eventData'],
        'campaignStatus': PromotionCampaignProgressStatusFromJSON(json['campaignStatus']),
        'rewardsIssuedTotal': json['rewardsIssuedTotal'],
        'progressCountAfter': json['progressCountAfter'],
        'progressCountBefore': json['progressCountBefore'],
        'rewardIssuedId': json['rewardIssuedId'] == null ? undefined : json['rewardIssuedId'],
        'qualifiedForReward': json['qualifiedForReward'],
        'triggerType': json['triggerType'],
        'campaignId': json['campaignId'],
        'id': json['id'],
    };
}

export function PromotionTriggerEventSummaryToJSON(value?: PromotionTriggerEventSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'failureReason': value['failureReason'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'eventData': value['eventData'],
        'campaignStatus': PromotionCampaignProgressStatusToJSON(value['campaignStatus']),
        'rewardsIssuedTotal': value['rewardsIssuedTotal'],
        'progressCountAfter': value['progressCountAfter'],
        'progressCountBefore': value['progressCountBefore'],
        'rewardIssuedId': value['rewardIssuedId'],
        'qualifiedForReward': value['qualifiedForReward'],
        'triggerType': value['triggerType'],
        'campaignId': value['campaignId'],
        'id': value['id'],
    };
}

